/*
 * @Description: 调度任务 api
 * @Date: 2020-07-22 18:11:39
 * @LastEditTime: 2020-07-22 18:27:31
 */ 

import request from '@/utils/request.js'

export function taskList(params) {
    return request({
        url: `/api/channel/task/`,
        method: 'get',
        params
    })
}

export function taskCreate(data) {
    return request({
        url: '/api/channel/task/',
        method: 'post',
        data
    })
}

export function taskUpdate(data) {
    return request({
        url: `/api/channel/task/${data.id}/`,
        method: 'put',
        data
    })
}

export function taskDelete(data) {
    return request({
        url: `/api/channel/task/${data.id}/`,
        method: 'delete'
    })
}

export function taskMakePlan(data) {
    return request({
        url: `/api/channel/task/${data.id}/make_plan/`,
        method: 'put',
        data
    })
}
